import { FunctionComponent, PropsWithChildren, SVGProps } from 'react';
import styles from './styles.module.scss';

export type IconSummaryProps = PropsWithChildren<{
    Icon: FunctionComponent<SVGProps<SVGSVGElement>>;
}>;

export const IconSummary: FunctionComponent<IconSummaryProps> = ({ Icon, children }) => {
    return (
        <div className={styles.container}>
            <div className={styles.iconContainer}>
                <Icon className={styles.icon} />
            </div>
            <div className={styles.content}>{children}</div>
        </div>
    );
};
